import React from 'react';
import PropTypes from 'prop-types';

import { withPolaris } from 'Components/protons/Polaris';

const ShopWindow = ({
  context: { cssPrefix },
}) => (
  <div className={`${cssPrefix}__shop-window`} />
);

ShopWindow.propTypes = {
  context: PropTypes.shape({
    cssPrefix: PropTypes.string,
  }).isRequired,
};

export default withPolaris(ShopWindow);
